// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2fsDD","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3HBvE","obliqueLine":"membershipbadge_obliqueLine__1yeE1"};